/**
 * Strategy mode constants + helpers for mapped master-strategy fanout.
 *
 * Mapped users see operator-owned External or Manual masters as "mapped" cards
 * alongside their own STANDARD strategies. Backend contract:
 *   GET   /strategy/strategies/mapped            → list caller's mappings
 *   PATCH /strategy/strategies/mapped/{id}       → self-edit execution overrides
 */

export const STRATEGY_MODES = {
  STANDARD:        'STANDARD',
  MASTER_EXTERNAL: 'MASTER_EXTERNAL',
  MASTER_MANUAL:   'MASTER_MANUAL',
};

export const MAPPING_STATUSES = {
  ACTIVE:   'ACTIVE',
  PAUSED:   'PAUSED',
  DISABLED: 'DISABLED',
  REMOVED:  'REMOVED',
};

// Discriminator guard for merged list items ({ _kind: 'standard' | 'mapped', data }).
export function isMappedStrategyCard(item) {
  return !!item && item._kind === 'mapped';
}

// Tailwind class helper for the mapping-status pill. Mirrors the StatusBadge
// idiom in Strategies.jsx (text-<tone> bg-<tone>/10 border border-<tone>/25).
export function mappingStatusBadgeClass(status) {
  const token = String(status || '').toUpperCase();
  switch (token) {
    case 'ACTIVE':
      return 'text-bull bg-bull/10 border border-bull/25';
    case 'PAUSED':
      return 'text-amber bg-amber/10 border border-amber/25';
    case 'DISABLED':
      return 'text-txt-muted bg-bg-hover border border-bg-border';
    case 'REMOVED':
      return 'text-bear bg-bear/10 border border-bear/25';
    default:
      return 'text-txt-muted bg-bg-hover border border-bg-border';
  }
}
